import { createContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { DEFAULT_TRUNCATION_MODE } from '../constants.js';

export const SankeyTruncationModeContext = createContext<TruncationMode>(
  DEFAULT_TRUNCATION_MODE,
);

SankeyTruncationModeContext['displayName'] = 'SankeyTruncationModeContext';
